export { default } from './ProductInfoBar';